/* @pareto-engineering/generator-front 1.1.1-alpha.2 */
import * as React from 'react';
import { useEffect } from 'react';
import { Formik, Form, FieldArray } from 'formik';
import PropTypes from 'prop-types';
import styleNames from '@pareto-engineering/bem/exports';
import { SelectInput } from "../../../../f";
import { Section } from "./common";
import "./styles.scss";

// Local Definitions

const baseClassName = styleNames.base;
const componentClassName = 'builder';
const reorderInputs = values => {
  const valuesCopy = JSON.parse(JSON.stringify(values));
  valuesCopy.sections.forEach(section => {
    const orderMap = new Map();
    section.orderedInputDragIds.forEach((id, index) => orderMap.set(id, index));
    section.inputs.sort((a, b) => orderMap.get(a.name) - orderMap.get(b.name));
  });
  return valuesCopy;
};

/**
 */
const Builder = ({
  id,
  className: userClassName,
  style,
  onSave,
  onError,
  validate,
  formBuilderId,
  initialValues = {}
  // ...otherProps
}) => {
  const handleSubmit = values => {
    const reOrderedValues = reorderInputs(values);
    onSave?.(reOrderedValues);
  };
  const initialFormState = initialValues?.sections ? initialValues : {
    sections: [{
      title: '',
      description: '',
      key: 'section-0',
      inputs: [],
      orderedInputDragIds: [],
      navigation: {
        nextSection: 'next'
      }
    }]
  };
  const handleDeleteSection = ({
    index,
    remove,
    values
  }) => {
    remove(index);
    values.sections.splice(index, 1);
    values.sections.forEach((section, sectionIndex) => {
      section.inputs.forEach((input, inputIndex) => {
        // eslint-disable-next-line no-param-reassign
        input.name = `section_${sectionIndex}_input_${inputIndex}`;
      });
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    className: [baseClassName, componentClassName, userClassName].filter(e => e).join(' '),
    style: style
  }, /*#__PURE__*/React.createElement("p", {
    className: "h3"
  }, "Form Builder"), /*#__PURE__*/React.createElement(Formik, {
    initialValues: initialFormState,
    onSubmit: handleSubmit,
    validate: validate
  }, ({
    values,
    errors,
    setFieldValue
  }) => {
    useEffect(() => {
      const reOrderedValues = reorderInputs(values);
      onSave?.(reOrderedValues);
    }, [values]);
    useEffect(() => {
      onError?.(errors);
    }, [errors, values]);
    const availableSections = values?.sections?.map((section, idx) => ({
      value: idx,
      label: `Go to ${section.title || `Untitled Section ${idx + 1}`}`
    }));
    return /*#__PURE__*/React.createElement(Form, {
      id: formBuilderId
    }, /*#__PURE__*/React.createElement(FieldArray, {
      name: "sections"
    }, ({
      push,
      remove
    }) => /*#__PURE__*/React.createElement(React.Fragment, null, values?.sections?.map((section, index) => /*#__PURE__*/React.createElement(Section, {
      key: section.key,
      index: index,
      handleDeleteSection: () => handleDeleteSection({
        index,
        remove,
        values,
        setFieldValue
      })
    })), /*#__PURE__*/React.createElement("div", {
      className: "section-footer"
    }, /*#__PURE__*/React.createElement("button", {
      className: "add-section-cta",
      type: "button",
      onClick: () => {
        const currentIndex = values.sections.length;
        return push({
          title: '',
          description: '',
          key: `section-${currentIndex}`,
          inputs: [{
            type: 'text',
            options: [],
            required: true,
            description: '',
            name: `section_${values.sections.length}_input_0`,
            label: ''
          }],
          orderedInputDragIds: [],
          navigation: {
            nextSection: 'next'
          }
        });
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "icon-container"
    }, /*#__PURE__*/React.createElement("span", {
      className: "icon"
    }, "+")), /*#__PURE__*/React.createElement("span", {
      className: "text x-paragraph c-x"
    }, "Add Section")), /*#__PURE__*/React.createElement("div", {
      className: "section-navigation"
    }, /*#__PURE__*/React.createElement("span", {
      className: "x-paragraph c-x"
    }, "After Section", ' ', values.sections.length), /*#__PURE__*/React.createElement(SelectInput, {
      name: `sections.${values.sections.length - 1}.navigation.nextSection`,
      options: [{
        label: 'Select section',
        value: '',
        disabled: true
      }, {
        label: 'Continue to next section',
        value: 'next'
      }, ...availableSections, {
        label: 'Submit form',
        value: 'submit'
      }]
    }))))));
  }));
};
Builder.propTypes = {
  /**
   * The HTML id for this element
   */
  id: PropTypes.string,
  /**
   * The HTML class names for this element
   */
  className: PropTypes.string,
  /**
   * The React-written, css properties for this element.
   */
  style: PropTypes.objectOf(PropTypes.string)
};
Builder.defaultProps = {
  // someProp:false
};
export default Builder;